export default "__VITE_ASSET__58567f88__"